(function () {
  'use strict';

  function moneyFromFormatted(formatted, fallbackCents) {
    if (formatted) return formatted;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && fallbackCents != null) {
      var format = (window.theme && theme.moneyFormat) || (window.moneyFormat) || '${{amount}}';
      return Shopify.formatMoney(fallbackCents, format);
    }
    if (fallbackCents != null) {
      return '$' + (Number(fallbackCents) / 100).toFixed(2);
    }
    return '';
  }

  function FluxSubscriptions(root) {
    this.root = root;
    this.form = root.closest('form');
    this.sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    this.variantBlocks = Array.prototype.slice.call(root.querySelectorAll('[data-variant-id]'));
    this.priceEls = document.querySelectorAll('.engoj_price_main, .product-price .enj-product-price');
    this.compareEls = document.querySelectorAll('.enj-product-price-compare');
    this.requiresPlan = root.getAttribute('data-requires-selling-plan') === 'true';

    this.bind();
    this.syncFromChecked();
  }

  FluxSubscriptions.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[type="radio"]')) {
        self.onPlanChange(event.target);
      }
    });

    this.listenForVariantChanges();
  };

  FluxSubscriptions.prototype.getVariantId = function () {
    if (!this.form) return null;

    var select = this.form.querySelector('select[name="id"]');
    if (select && select.value) return String(select.value);

    var input = this.form.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);

    return null;
  };

  FluxSubscriptions.prototype.showVariantBlock = function (variantId) {
    var id = String(variantId || '');
    this.variantBlocks.forEach(function (block) {
      var match = String(block.getAttribute('data-variant-id')) === id;
      block.classList.toggle('is-hidden', !match);
      if (match) {
        block.removeAttribute('hidden');
      } else {
        block.setAttribute('hidden', 'hidden');
      }
    });
  };

  FluxSubscriptions.prototype.getActiveRadios = function () {
    var variantId = this.getVariantId();
    var block = this.root.querySelector('[data-variant-id="' + variantId + '"]');
    if (!block) return [];
    return Array.prototype.slice.call(block.querySelectorAll('input[type="radio"]'));
  };

  FluxSubscriptions.prototype.syncFromChecked = function () {
    var radios = this.getActiveRadios();
    var checked = radios.find(function (radio) { return radio.checked; }) || radios[0];
    if (checked) {
      if (!checked.checked) checked.checked = true;
      this.onPlanChange(checked);
    }
  };

  FluxSubscriptions.prototype.onPlanChange = function (input) {
    if (!input) return;

    var planId = input.getAttribute('data-selling-plan-id') || '';
    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = planId;
    }

    // Keep any secondary product forms (dynamic checkout) in sync
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (el) {
      el.value = planId;
    });

      this.updatePrice(input);
      this.updatePlanDescriptions(planId);
      this.syncDynamicCheckout(planId);
    };

  FluxSubscriptions.prototype.syncDynamicCheckout = function (planId) {
    var variantId = this.getVariantId();
    var checkoutForm = document.getElementById('flux-dynamic-checkout-form');
    if (!checkoutForm) return;

    var variantInput = checkoutForm.querySelector('[data-dynamic-checkout-variant], input[name="id"]');
    if (variantInput && variantId) variantInput.value = variantId;

    var planInput = checkoutForm.querySelector('[data-selling-plan-input], input[name="selling_plan"]');
    if (planInput) planInput.value = planId || '';
  };

  FluxSubscriptions.prototype.updatePrice = function (input) {
    var priceFormatted = moneyFromFormatted(
      input.getAttribute('data-price-formatted'),
      input.getAttribute('data-price')
    );
    var compareFormatted = input.getAttribute('data-compare-at-formatted') || '';

    this.priceEls.forEach(function (el) {
      el.textContent = priceFormatted;
    });

    this.compareEls.forEach(function (el) {
      if (compareFormatted) {
        el.textContent = compareFormatted;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  };

  FluxSubscriptions.prototype.updatePlanDescriptions = function (planId) {
    this.root.querySelectorAll('[data-plan-desc-for]').forEach(function (el) {
      var match = String(el.getAttribute('data-plan-desc-for')) === String(planId);
      el.classList.toggle('is-visible', match);
    });
  };

  FluxSubscriptions.prototype.listenForVariantChanges = function () {
    var self = this;
    if (!this.form) return;

    var variantSelect = this.form.querySelector('select[name="id"], #productSelect');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        self.showVariantBlock(variantSelect.value);
        self.syncFromChecked();
      });
    }

    // Theme variant picker often updates a hidden input / triggers custom events
    document.addEventListener('flux:variant:change', function (event) {
      var detail = event.detail || {};
      var id = detail.variant && detail.variant.id ? detail.variant.id : null;
      if (id) {
        self.showVariantBlock(id);
        window.setTimeout(function () {
          self.syncFromChecked();
        }, 0);
      }
    });

    document.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var id = detail.variant && detail.variant.id ? detail.variant.id : detail.id;
      if (id) {
        self.showVariantBlock(id);
        window.setTimeout(function () {
          self.syncFromChecked();
        }, 0);
      }
    });

    // Fallback: observe select/value mutations used by option_selection.js
    if (variantSelect && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        self.showVariantBlock(self.getVariantId());
        window.setTimeout(function () {
          self.syncFromChecked();
        }, 0);
      });
      observer.observe(variantSelect, { attributes: true, childList: true, subtree: true });
    }

    // jQuery theme hooks
    if (window.jQuery) {
      jQuery(document).on('change', '#productSelect, select[name="id"]', function () {
        self.showVariantBlock(this.value);
        window.setTimeout(function () {
          self.syncFromChecked();
        }, 0);
      });
    }
  };

  function initAll() {
    document.querySelectorAll('[data-flux-subscriptions]').forEach(function (root) {
      if (root.dataset.fluxInit === 'true') return;
      root.dataset.fluxInit = 'true';
      new FluxSubscriptions(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

/* Flux multi-unit subscription totals and quantities - 2026-09-01 */
(function () {
  var PLAN_SELECTOR = '[data-flux-subscriptions] input[data-selling-plan-id]';
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function unitsFor(input) {
    if (!input || !input.getAttribute('data-selling-plan-id')) return 1;
    var label = input.closest('label');
    var match = (label ? label.textContent : '').match(/every\s+(\d+)\s+months?/i);
    return match ? Number(match[1]) : 1;
  }
  function ensureQuantity(form, quantity) {
    if (!form) return;
    var field = form.querySelector('input[name="quantity"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'quantity';
      form.appendChild(field);
    }
    field.value = String(quantity);
  }
  function renderTotals(root) {
    var inputs = Array.prototype.slice.call(root.querySelectorAll('input[data-selling-plan-id]'));
    var oneTime = inputs.find(function (input) { return !input.getAttribute('data-selling-plan-id'); });
    if (!oneTime) return;
    var basePrice = Number(oneTime.getAttribute('data-price') || 0);
    var foundingUnitPrice = basePrice;
    var itemName = basePrice >= 10000 ? 'bundle' : 'bottle';
    inputs.forEach(function (input) {
      if (!input.getAttribute('data-selling-plan-id')) return;
      var quantity = unitsFor(input);
      var total = Number(input.getAttribute('data-price') || 0) * quantity;
      var comparisonTotal = foundingUnitPrice * quantity;
      var savings = comparisonTotal ? Math.round((1 - total / comparisonTotal) * 100) : 0;
      var label = input.closest('label');
      if (!label) return;
      var title = label.querySelector('.flux-subscriptions__option-title');
      var price = label.querySelector('.flux-subscriptions__option-price');
      var dayCount = quantity * 30;
      var plural = quantity === 1 ? itemName : itemName + 's';
      if (title) {
        title.innerHTML = quantity + ' ' + plural + ' delivered every ' + dayCount +
          ' days, ' + money(total) + ' total <span class="flux-subscriptions__badge">Save ' +
          savings + '%</span>';
      }
      if (price) price.innerHTML = '<s>' + money(comparisonTotal) + '</s>' + money(total);
    });
  }
  function syncSelection(input) {
    if (!input) return;
    var quantity = unitsFor(input);
    ensureQuantity(document.getElementById('AddToCartForm'), quantity);
    ensureQuantity(document.getElementById('flux-dynamic-checkout-form'), quantity);
  }
  function initializeFluxTotals() {
    document.querySelectorAll('[data-flux-subscriptions]').forEach(function (root) {
      renderTotals(root);
      syncSelection(root.querySelector('input[data-selling-plan-id]:checked'));
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches(PLAN_SELECTOR)) syncSelection(event.target);
  });
  document.addEventListener('submit', function (event) {
    if (event.target && (event.target.id === 'AddToCartForm' || event.target.id === 'flux-dynamic-checkout-form')) {
      syncSelection(document.querySelector(PLAN_SELECTOR + ':checked'));
    }
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFluxTotals);
  } else {
    initializeFluxTotals();
  }
})();

/* Flux selling-plan quantity enforcement */
(function () {
  var quantityByPlan = {
    '3673423974': 1,
    '3673456742': 2,
    '3673489510': 3,
    '3673522278': 1,
    '3673555046': 2,
    '3673587814': 3
  };
  function applyFluxQuantity() {
    var selected = document.querySelector('[data-flux-subscriptions] input[data-selling-plan-id]:checked');
    var planId = selected ? selected.getAttribute('data-selling-plan-id') : '';
    var quantity = quantityByPlan[planId] || 1;
    ['AddToCartForm', 'flux-dynamic-checkout-form'].forEach(function (formId) {
      var form = document.getElementById(formId);
      if (!form) return;
      var input = form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      }
      input.value = String(quantity);
      input.setAttribute('value', String(quantity));
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-flux-subscriptions] input[data-selling-plan-id]')) {
      applyFluxQuantity();
    }
  });
  document.addEventListener('submit', applyFluxQuantity, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFluxQuantity);
  } else {
    window.setTimeout(applyFluxQuantity, 0);
  }
})();

/* Capture plan selection before theme handlers stop propagation. */
(function () {
  var quantities = {
    '3673423974': 1, '3673456742': 2, '3673489510': 3,
    '3673522278': 1, '3673555046': 2, '3673587814': 3
  };
  function enforce(input) {
    var planId = input ? input.getAttribute('data-selling-plan-id') : '';
    var quantity = quantities[planId] || 1;
    ['AddToCartForm', 'flux-dynamic-checkout-form'].forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      var field = form.querySelector('input[name="quantity"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'quantity';
        form.appendChild(field);
      }
      field.value = String(quantity);
      field.defaultValue = String(quantity);
      field.setAttribute('value', String(quantity));
    });
  }
  function onSelection(event) {
    if (event.target && event.target.matches('[data-flux-subscriptions] input[data-selling-plan-id]')) {
      enforce(event.target);
    }
  }
  document.addEventListener('click', onSelection, true);
  document.addEventListener('change', onSelection, true);
  document.addEventListener('submit', function () {
    enforce(document.querySelector('[data-flux-subscriptions] input[data-selling-plan-id]:checked'));
  }, true);
  window.setTimeout(function () {
    enforce(document.querySelector('[data-flux-subscriptions] input[data-selling-plan-id]:checked'));
  }, 250);
})();

/* Direct radio binding for cart quantities. */
(function () {
  var quantities = {
    '3673423974': 1, '3673456742': 2, '3673489510': 3,
    '3673522278': 1, '3673555046': 2, '3673587814': 3
  };
  function setQuantity(input) {
    var quantity = quantities[input ? input.getAttribute('data-selling-plan-id') : ''] || 1;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.id !== 'AddToCartForm' && form.id !== 'flux-dynamic-checkout-form') return;
      var field = form.querySelector('input[name="quantity"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'quantity';
        form.appendChild(field);
      }
      field.setAttribute('value', String(quantity));
      field.value = String(quantity);
    });
  }
  function bindFluxQuantity() {
    document.querySelectorAll('[data-flux-subscriptions] input[data-selling-plan-id]').forEach(function (input) {
      if (input.getAttribute('data-flux-quantity-bound') === 'true') return;
      input.setAttribute('data-flux-quantity-bound', 'true');
      input.addEventListener('click', function () { setQuantity(input); });
      input.addEventListener('change', function () { setQuantity(input); });
    });
    setQuantity(document.querySelector('[data-flux-subscriptions] input[data-selling-plan-id]:checked'));
  }
  window.setTimeout(bindFluxQuantity, 0);
  window.setTimeout(bindFluxQuantity, 500);
  document.addEventListener('shopify:section:load', bindFluxQuantity);
})();

/* Correct form ID handling when a form contains name="id". */
(function () {
  var quantities = {
    '3673423974': 1, '3673456742': 2, '3673489510': 3,
    '3673522278': 1, '3673555046': 2, '3673587814': 3
  };
  function apply(input) {
    var quantity = quantities[input ? input.getAttribute('data-selling-plan-id') : ''] || 1;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var formId = form.getAttribute('id');
      if (formId !== 'AddToCartForm' && formId !== 'flux-dynamic-checkout-form') return;
      var field = form.querySelector('input[name="quantity"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'quantity';
        form.appendChild(field);
      }
      field.value = String(quantity);
      field.setAttribute('value', String(quantity));
    });
  }
  function bind() {
    document.querySelectorAll('[data-flux-subscriptions] input[data-selling-plan-id]').forEach(function (input) {
      if (input.getAttribute('data-flux-quantity-fixed') === 'true') return;
      input.setAttribute('data-flux-quantity-fixed', 'true');
      input.addEventListener('click', function () { apply(input); });
      input.addEventListener('change', function () { apply(input); });
    });
    apply(document.querySelector('[data-flux-subscriptions] input[data-selling-plan-id]:checked'));
  }
  window.setTimeout(bind, 0);
  window.setTimeout(bind, 500);
  document.addEventListener('shopify:section:load', bind);
})();

/* Apply quantity after all theme plan handlers finish. */
(function () {
  var quantities = {
    '3673423974': 1, '3673456742': 2, '3673489510': 3,
    '3673522278': 1, '3673555046': 2, '3673587814': 3
  };
  function apply(input) {
    var quantity = quantities[input ? input.getAttribute('data-selling-plan-id') : ''] || 1;
    document.documentElement.setAttribute('data-flux-last-quantity', String(quantity));
    ['AddToCartForm', 'flux-dynamic-checkout-form'].forEach(function (id) {
      var form = document.querySelector('form[id="' + id + '"]');
      if (!form) return;
      var field = form.querySelector('input[name="quantity"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'quantity';
        form.appendChild(field);
      }
      field.value = String(quantity);
      field.setAttribute('value', String(quantity));
    });
  }
  function schedule(input) {
    apply(input);
    window.setTimeout(function () { apply(input); }, 0);
    window.setTimeout(function () { apply(input); }, 100);
  }
  document.querySelectorAll('[data-flux-subscriptions] input[data-selling-plan-id]').forEach(function (input) {
    input.addEventListener('change', function () { schedule(input); });
    input.addEventListener('click', function () { schedule(input); });
  });
  window.setTimeout(function () {
    schedule(document.querySelector('[data-flux-subscriptions] input[data-selling-plan-id]:checked'));
  }, 600);
})();

/* Remove international delivery claims from product details. */
(function () {
  function enforceUsDeliveryCopy() {
    document.querySelectorAll('li').forEach(function (item) {
      var text = (item.textContent || '').trim();
      if (/Europe\s*&\s*USA\s+within/i.test(text)) {
        item.textContent = 'United States delivery only';
      } else if (/Rest of the world\s+within/i.test(text)) {
        item.remove();
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceUsDeliveryCopy);
  } else {
    enforceUsDeliveryCopy();
  }
  document.addEventListener('shopify:section:load', enforceUsDeliveryCopy);
})();
